// extracted by mini-css-extract-plugin
export default {"dash_page":"qrCodeAndLink_dash_page__qmHxY","Container":"qrCodeAndLink_Container__2o4-o","org":"qrCodeAndLink_org__NiDqI"};